export function bodyCol(old) {
  const body = document.querySelector('body');
  const cols = ['bg-white'];
  const classes = cols.filter(col => col !== old);
  body.classList.remove(...cols);
  body.classList.add(classes[~~(classes.length * Math.random())]);
}
